<template>
  <div class="ppm-container">
    <div
      v-if="listName"
      class="title"
    >
      <h2>{{ listName }}</h2>
    </div>
    <div
      v-if="linkToMore"
      class="link"
    >
      <span class="nav-link text-primary underline decoration-solid text-center"> Alle Artikel anzeigen </span>
    </div>
    <BasicSlider
      class="slider"
      :slides="slides"
      :config="carouselConfig"
    >
      <template #default="">
        <SkeletonArticleCard />
      </template>
    </BasicSlider>
  </div>
</template>

<script setup lang="ts">
import { CarouselAlignment } from '~~/models/NuxtCarousel';

interface Props {
  listName: string;
  linkToMore: boolean;
  numberOfSlides?: number;
}

const props = withDefaults(defineProps<Props>(), {
  numberOfSlides: 12,
});

const carouselConfig = ref({
  height: 460,
  gap: 15,
  breakpoints: {
    900: {
      itemsToShow: 4,
      snapAlign: CarouselAlignment.START,
    },
  },
});

const slides = computed(() => {
  let count = 0;
  return new Array(props.numberOfSlides).fill({ id: count++ });
});
</script>

<style scoped>
.ppm-container {
  display: grid;
  grid-template-areas:
    'title title'
    'slider slider'
    'link link';
  grid-template-columns: repeat(2, 1fr);
}

.title {
  @apply text-lg font-bold;
  grid-area: title;
}

.link {
  grid-area: link;
}

.slider {
  grid-area: slider;
}

.ppm-slide {
  height: 100%;
  width: 75%;
  max-width: 250px;
  margin: 0 auto;
}

@media (min-width: 1200px) {
  .ppm-container {
    grid-template-areas:
      'title link'
      'slider slider';
    row-gap: 0.5rem;
  }

  .link {
    display: flex;
    justify-content: end;
  }

  .title {
    display: flex;
    align-items: center;
  }

  .ppm-slide {
    width: auto;
  }
}
</style>
